export default {
  getLanguage: state => state.uiLanguage,
  getSupportedLanguages: state => state.supportedLanguages,
  getUser: state => state.user,
  getFinanceAccount: state => (state.user || {}).id,
  getMetaInfo: state => (state.metaInfo),
  getCVStatus: state => state.userHasCV,
  reRenderPageCounter: state => state.reRenderPageCounter
}



// WEBPACK FOOTER //
// ./src/store/getters.js